import './collapsible-header.scss'

import { ReactiveVue } from '@skinsoft/reactive-vue';
import Component from "vue-class-component";

@Component({
    components: {
    },
    props: ['title', 'displayBottom', 'statusMessage'],
    template: require("./collapsible-header.html")
})
export class CollapsibleHeader extends ReactiveVue {

    public title: string;
    public displayBottom;
    private statusMessage: string

}